// // public/src/pages/ProjectDetail.jsx - FIXED VERSION
// import React, { useState, useEffect } from "react";
// import { useParams, Link } from "react-router-dom";
// import { motion } from "framer-motion";
// import {
//   FiArrowLeft,
//   FiMapPin,
//   FiCalendar,
//   FiUsers,
//   FiTarget,
// } from "react-icons/fi";
// import axios from "axios";

// function ProjectDetail() {
//   const { id } = useParams();
//   const [project, setProject] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     fetchProject();
//   }, [id]);

//   const fetchProject = async () => {
//     try {
//       const response = await axios.get(
//         `https://agri-back-mauve.vercel.app/api/content/public/project/${id}`
//       );
//       if (response.data.success) {
//         setProject(response.data.data);
//       } else {
//         setError("Project not found");
//       }
//     } catch (err) {
//       setError("Failed to load project details");
//       console.error("Error fetching project:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
//           <p>Loading project details...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error || !project) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="text-red-500 text-6xl mb-4">❌</div>
//           <h2 className="text-2xl font-bold text-gray-900 mb-2">
//             Project Not Found
//           </h2>
//           <p className="text-gray-600 mb-4">{error}</p>
//           <Link
//             to="/projects"
//             className="text-green-600 hover:text-green-700 font-medium"
//           >
//             Back to Projects
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   // Handle nested project data structure
//   const projectData = project.project || project;

//   return (
//     <div className="project-detail-page">
//       {/* Hero Section */}
//       <section className="page-hero">
//         <div className="container">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="hero-content"
//           >
//             <Link to="/projects" className="back-link">
//               <FiArrowLeft /> Back to Projects
//             </Link>
//             <h1>{project.title}</h1>
//             <p className="client-name">
//               {projectData.client || project.client}
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       <div className="container">
//         {/* Project Gallery */}
//         {project.images && project.images.length > 0 && (
//           <motion.section
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="project-gallery"
//           >
//             <div className="gallery-grid">
//               {project.images.map((image, index) => (
//                 <div key={index} className="gallery-item">
//                   <img
//                     src={
//                       image.startsWith("http")
//                         ? image
//                         : `https://agri-back-mauve.vercel.app${image}`
//                     }
//                     alt={`${project.title} - Image ${index + 1}`}
//                   />
//                 </div>
//               ))}
//             </div>
//           </motion.section>
//         )}

//         {/* Main project image if no gallery images */}
//         {project.image && (!project.images || project.images.length === 0) && (
//           <motion.section
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="project-main-image"
//           >
//             <img
//               src={
//                 project.image.startsWith("http")
//                   ? project.image
//                   : `https://agri-back-mauve.vercel.app${project.image}`
//               }
//               alt={project.title}
//               className="main-project-image"
//             />
//           </motion.section>
//         )}

//         <div className="project-detail-content">
//           {/* Main Content */}
//           <div className="project-main">
//             <motion.div
//               initial={{ opacity: 0, x: -20 }}
//               animate={{ opacity: 1, x: 0 }}
//               className="project-overview"
//             >
//               <h2>Project Overview</h2>
//               <p>{project.description}</p>

//               {/* Challenge & Solution */}
//               <div className="challenge-solution-grid">
//                 <div className="challenge-section">
//                   <h3>The Challenge</h3>
//                   <p>
//                     {projectData.challenge ||
//                       "No challenge description provided."}
//                   </p>
//                 </div>
//                 <div className="solution-section">
//                   <h3>Our Solution</h3>
//                   <p>
//                     {projectData.solution ||
//                       "No solution description provided."}
//                   </p>
//                 </div>
//               </div>

//               {/* Results */}
//               {projectData.results && (
//                 <div className="results-section">
//                   <h3>Results Achieved</h3>
//                   <p>
//                     {projectData.results.description ||
//                       "Significant improvements achieved through our solutions."}
//                   </p>

//                   {projectData.results.metrics &&
//                     projectData.results.metrics.length > 0 && (
//                       <div className="metrics-grid">
//                         {projectData.results.metrics.map((metric, index) => (
//                           <div key={index} className="metric-card">
//                             <div className="metric-value">
//                               {metric.value || "N/A"}
//                             </div>
//                             <div className="metric-label">
//                               {metric.label || "Metric"}
//                             </div>
//                             {metric.improvement && (
//                               <div className="metric-improvement">
//                                 {metric.improvement}
//                               </div>
//                             )}
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                 </div>
//               )}

//               {/* Technologies */}
//               {projectData.technologies &&
//                 projectData.technologies.length > 0 && (
//                   <div className="technologies-section">
//                     <h3>Technologies Used</h3>
//                     <div className="technologies-tags">
//                       {projectData.technologies.map((tech, index) => (
//                         <span key={index} className="tech-tag">
//                           {tech}
//                         </span>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//             </motion.div>
//           </div>

//           {/* Sidebar */}
//           <motion.div
//             initial={{ opacity: 0, x: 20 }}
//             animate={{ opacity: 1, x: 0 }}
//             className="project-sidebar"
//           >
//             <div className="sidebar-card">
//               <h3>Project Details</h3>

//               <div className="detail-item">
//                 <FiMapPin className="detail-icon" />
//                 <div>
//                   <strong>Location</strong>
//                   <p>
//                     {projectData.location ||
//                       project.location ||
//                       "Not specified"}
//                   </p>
//                 </div>
//               </div>

//               <div className="detail-item">
//                 <FiCalendar className="detail-icon" />
//                 <div>
//                   <strong>Duration</strong>
//                   <p>
//                     {projectData.timeline?.duration ||
//                       projectData.duration ||
//                       "Not specified"}
//                   </p>
//                 </div>
//               </div>

//               <div className="detail-item">
//                 <FiTarget className="detail-icon" />
//                 <div>
//                   <strong>Category</strong>
//                   <p>{project.category || "General"}</p>
//                 </div>
//               </div>

//               <div className="detail-item">
//                 <FiUsers className="detail-icon" />
//                 <div>
//                   <strong>Status</strong>
//                   <p
//                     className={`status ${projectData.status || project.status}`}
//                   >
//                     {(projectData.status || project.status || "completed")
//                       .charAt(0)
//                       .toUpperCase() +
//                       (
//                         projectData.status ||
//                         project.status ||
//                         "completed"
//                       ).slice(1)}
//                   </p>
//                 </div>
//               </div>

//               {(projectData.budget || project.budget) && (
//                 <div className="detail-item">
//                   <div>
//                     <strong>Budget</strong>
//                     <p>{projectData.budget || project.budget}</p>
//                   </div>
//                 </div>
//               )}

//               {projectData.teamSize && (
//                 <div className="detail-item">
//                   <div>
//                     <strong>Team Size</strong>
//                     <p>{projectData.teamSize} people</p>
//                   </div>
//                 </div>
//               )}

//               <Link to="/contact" className="cta-button primary full-width">
//                 Start Similar Project
//               </Link>
//             </div>
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ProjectDetail;

// public/src/pages/ProjectDetail.jsx - PROFESSIONAL STYLING WITH DARK MODE
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FiArrowLeft,
  FiMapPin,
  FiCalendar,
  FiUsers,
  FiTarget,
  FiAward,
  FiBarChart2,
  FiCheck,
  FiGlobe,
} from "react-icons/fi";
import axios from "axios";

function ProjectDetail() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchProject();
  }, [id]);

  const fetchProject = async () => {
    try {
      const response = await axios.get(
        `https://agri-back-mauve.vercel.app/api/content/public/project/${id}`
      );
      if (response.data.success) {
        setProject(response.data.data);
      } else {
        setError("Project not found");
      }
    } catch (err) {
      setError("Failed to load project details");
      console.error("Error fetching project:", err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "completed":
        return "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300";
      case "ongoing":
        return "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300";
      case "upcoming":
        return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300";
      default:
        return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300";
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading project details...</p>
        </div>
      </div>
    );
  }

  if (error || !project) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 text-6xl mb-4">❌</div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            Project Not Found
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-4">{error}</p>
          <Link
            to="/projects"
            className="text-green-600 dark:text-green-400 hover:text-green-700 dark:hover:text-green-300 font-medium"
          >
            Back to Projects
          </Link>
        </div>
      </div>
    );
  }

  // Handle nested project data structure
  const projectData = project.project || project;

  return (
    <div className="project-detail-page min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Hero Section */}
      <section className="page-hero bg-gradient-to-r from-green-900 to-emerald-800 text-white py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-6xl mx-auto"
          >
            <Link 
              to="/projects" 
              className="back-link inline-flex items-center gap-2 text-green-200 hover:text-white mb-6 transition-colors duration-300"
            >
              <FiArrowLeft className="w-4 h-4" />
              Back to Projects
            </Link>
            
            <div className="flex flex-col lg:flex-row items-start justify-between gap-8">
              <div className="flex-1">
                <div className="flex items-center gap-4 mb-4">
                  <span className={`status-badge px-4 py-2 rounded-full text-sm font-semibold ${getStatusColor(projectData.status)}`}>
                    {projectData.status || project.status}
                  </span>
                  <span className="project-category px-4 py-2 bg-white/20 text-white rounded-full text-sm font-semibold">
                    {project.category}
                  </span>
                </div>
                
                <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight">
                  {project.title}
                </h1>
                <p className="text-xl text-green-200 leading-relaxed">
                  {project.description}
                </p>
              </div>
              
              {project.image && (
                <div className="project-hero-image w-full lg:w-96 h-64 lg:h-80 rounded-2xl overflow-hidden shadow-2xl">
                  <img
                    src={project.image.startsWith("http") ? project.image : `https://agri-back-mauve.vercel.app${project.image}`}
                    alt={project.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              )}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="main-content py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              {/* Main Content Column */}
              <div className="lg:col-span-2 space-y-12">
                {/* Project Overview */}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.1 }}
                  className="project-overview bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8"
                >
                  <h2 className="text-3xl font-bold text-gray-800 dark:text-white mb-6 flex items-center gap-3">
                    <FiTarget className="text-green-500" />
                    Project Overview
                  </h2>
                  <p className="text-gray-600 dark:text-gray-300 text-lg leading-relaxed mb-6">
                    {project.description}
                  </p>
                  
                  {project.content && (
                    <div className="prose prose-lg dark:prose-invert max-w-none">
                      <p className="text-gray-600 dark:text-gray-300">
                        {project.content}
                      </p>
                    </div>
                  )}
                </motion.div>

                {/* Challenge & Solution */}
                {(projectData.challenge || projectData.solution) && (
                  <div className="challenge-solution-grid grid grid-cols-1 md:grid-cols-2 gap-8">
                    {projectData.challenge && (
                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        className="challenge-section bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8"
                      >
                        <h3 className="text-2xl font-bold text-gray-800 dark:text-white mb-6 flex items-center gap-3">
                          <FiAward className="text-red-500" />
                          The Challenge
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                          {projectData.challenge}
                        </p>
                      </motion.div>
                    )}

                    {projectData.solution && (
                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                        className="solution-section bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8"
                      >
                        <h3 className="text-2xl font-bold text-gray-800 dark:text-white mb-6 flex items-center gap-3">
                          <FiCheck className="text-green-500" />
                          Our Solution
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                          {projectData.solution}
                        </p>
                      </motion.div>
                    )}
                  </div>
                )}

                {/* Results & Impact */}
                {projectData.results && (
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.4 }}
                    className="results-section bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8"
                  >
                    <h3 className="text-2xl font-bold text-gray-800 dark:text-white mb-6 flex items-center gap-3">
                      <FiBarChart2 className="text-green-500" />
                      Results & Impact
                    </h3>
                    
                    {projectData.results.description && (
                      <p className="text-gray-600 dark:text-gray-300 text-lg leading-relaxed mb-6">
                        {projectData.results.description}
                      </p>
                    )}

                    {projectData.results.metrics && projectData.results.metrics.length > 0 && (
                      <div className="metrics-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {projectData.results.metrics.map((metric, index) => (
                          <div key={index} className="metric-card bg-green-50 dark:bg-green-900/20 rounded-xl p-6 text-center">
                            <div className="metric-value text-3xl font-bold text-green-600 dark:text-green-400 mb-2">
                              {metric.value}
                            </div>
                            <div className="metric-label text-gray-700 dark:text-gray-300 font-medium">
                              {metric.label}
                            </div>
                            {metric.improvement && (
                              <div className="metric-improvement text-sm text-green-600 dark:text-green-400 mt-2">
                                {metric.improvement}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </motion.div>
                )}

                {/* Technologies */}
                {projectData.technologies && projectData.technologies.length > 0 && (
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.5 }}
                    className="technologies-section bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8"
                  >
                    <h3 className="text-2xl font-bold text-gray-800 dark:text-white mb-6 flex items-center gap-3">
                      <FiGlobe className="text-green-500" />
                      Technologies Used
                    </h3>
                    <div className="technologies-tags flex flex-wrap gap-3">
                      {projectData.technologies.map((tech, index) => (
                        <span 
                          key={index} 
                          className="tech-tag px-4 py-2 bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300 rounded-full text-sm font-medium border border-green-200 dark:border-green-700"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </motion.div>
                )}
              </div>

              {/* Sidebar Column */}
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 }}
                className="project-sidebar space-y-6"
              >
                {/* Project Details Card */}
                <div className="sidebar-card bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 sticky top-6">
                  <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-6 pb-4 border-b border-gray-200 dark:border-gray-700">
                    Project Details
                  </h3>

                  <div className="space-y-4">
                    {project.client && (
                      <div className="detail-item flex items-start gap-4 p-3 rounded-lg bg-gray-50 dark:bg-gray-700/50">
                        <FiUsers className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                        <div>
                          <strong className="text-gray-700 dark:text-gray-300 block">Client</strong>
                          <p className="text-gray-600 dark:text-gray-400">{project.client}</p>
                        </div>
                      </div>
                    )}

                    {project.location && (
                      <div className="detail-item flex items-start gap-4 p-3 rounded-lg bg-gray-50 dark:bg-gray-700/50">
                        <FiMapPin className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                        <div>
                          <strong className="text-gray-700 dark:text-gray-300 block">Location</strong>
                          <p className="text-gray-600 dark:text-gray-400">{project.location}</p>
                        </div>
                      </div>
                    )}

                    {projectData.timeline && (
                      <div className="detail-item flex items-start gap-4 p-3 rounded-lg bg-gray-50 dark:bg-gray-700/50">
                        <FiCalendar className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                        <div>
                          <strong className="text-gray-700 dark:text-gray-300 block">Timeline</strong>
                          <p className="text-gray-600 dark:text-gray-400">
                            {projectData.timeline.startDate && (
                              <span>{new Date(projectData.timeline.startDate).toLocaleDateString()}</span>
                            )}
                            {projectData.timeline.endDate && (
                              <span> - {new Date(projectData.timeline.endDate).toLocaleDateString()}</span>
                            )}
                          </p>
                        </div>
                      </div>
                    )}

                    {projectData.teamSize && (
                      <div className="detail-item flex items-start gap-4 p-3 rounded-lg bg-gray-50 dark:bg-gray-700/50">
                        <FiUsers className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                        <div>
                          <strong className="text-gray-700 dark:text-gray-300 block">Team Size</strong>
                          <p className="text-gray-600 dark:text-gray-400">{projectData.teamSize} members</p>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* CTA Button */}
                  <div className="cta-section mt-6 pt-6 border-t border-gray-200 dark:border-gray-700">
                    <Link 
                      to="/contact" 
                      className="cta-button w-full bg-gradient-to-r from-green-500 to-emerald-500 text-white text-center py-4 rounded-xl font-bold text-lg hover:from-green-600 hover:to-emerald-600 transition-all duration-300 shadow-lg hover:shadow-xl block"
                    >
                      Start Similar Project
                    </Link>
                    <p className="text-center text-gray-500 dark:text-gray-400 text-sm mt-3">
                      Free project consultation
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Projects CTA */}
      <section className="related-cta py-16 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-800 dark:text-white mb-4">
              Explore More Projects
            </h2>
            <p className="text-gray-600 dark:text-gray-300 text-lg mb-8">
              Discover how we've helped other organizations transform their agricultural operations.
            </p>
            <Link
              to="/projects"
              className="inline-flex items-center gap-2 px-8 py-4 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              View All Projects
              <FiArrowLeft className="w-5 h-5 transform rotate-180" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ProjectDetail;